import React from 'react'
import { useTranslation } from 'react-i18next'

import SpreadSheet from '../../../../components/SpreadSheet'

import { APPS } from '../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

import useDrawerFormStyles from '../../../../styles/common/drawerForms'
import useStyles from './styles'

const errorRowsIndexes = []
const appsSpreadSheetColumnLabels = ['App', 'Exclude app']

const AppsSection = ({ formik }) => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const { values, setFieldValue, errors, touched } = formik

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('List of apps to target')}</h3>
      <p>{t('You can paste the list from another spreadsheet and we will automatically add enough rows.')}</p>
      <SpreadSheet
        name={APPS}
        setFieldValue={setFieldValue}
        formikData={values[APPS]}
        columnLabels={appsSpreadSheetColumnLabels}
        maxRows={500}
        className={classes.spreadSheet}
        tableClassName={classes.spreadSheetTable}
        error={touched[APPS] && errors[APPS]}
        errorRowsIndexes={errorRowsIndexes}
      />
    </section>
  )
}

export default AppsSection
